/** Admin: collection monitoring (registry tree, documents, audiences). */
import { apiGet } from '../client.js';
import type { CollectionDocument, CollectionTree } from '../types.js';

export function listOrgCollections(
  organizationId: string,
): Promise<CollectionTree> {
  return apiGet<CollectionTree>(
    `/api/v1/admin/organizations/${organizationId}/collections`,
  );
}

export function listOrgCollectionDocuments(
  organizationId: string,
  filters: { path?: string; limit?: number } = {},
): Promise<CollectionDocument[]> {
  const query: Record<string, string> = {};
  if (filters.path) query.path = filters.path;
  if (filters.limit) query.limit = String(filters.limit);
  return apiGet<CollectionDocument[]>(
    `/api/v1/admin/organizations/${organizationId}/collections/documents`,
    query,
  );
}
